import { InventoryOrder, InventoryOrderItem, InventoryOrderStatus } from '@api/InventoryOrders/InventoryOrder';
import InventoryOrderServ from '@api/InventoryOrders/InventoryOrderServ';

class InventoryOrderService {
    saveInventoryOrder = (inventoryOrder: InventoryOrder): Promise<InventoryOrder> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await InventoryOrderServ.saveInventoryOrder(inventoryOrder);
                resolve(data);
            } catch (error) {
                reject('Error saving inventory order: ' + error);
            }
        });
    };

    getInventoryOrders = (
        branchOfficeId?: string,
        distributionCenterId?: string,
        status?: string
    ): Promise<InventoryOrder[]> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await InventoryOrderServ.getInventoryOrders(branchOfficeId, distributionCenterId, status);
                resolve(data);
            } catch (error) {
                console.log(error);
                reject('Error getting inventory orders: ' + error);
            }
        });
    };

    getShoppingList = (distributionCenterId?: string): Promise<InventoryOrderItem[]> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await InventoryOrderServ.getShoppingList(distributionCenterId);
                resolve(data);
            } catch (error) {
                console.log(error);
                reject('Error getting shopping list: ' + error);
            }
        });
    };

    getInventoryOrder = (inventoryOrderId: string): Promise<InventoryOrder> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await InventoryOrderServ.getInventoryOrder(inventoryOrderId);
                resolve(data);
            } catch (error) {
                reject('Error getting inventory order: ' + error);
            }
        });
    };

    updateInventoryOrderItems = (inventoryOrderId: string, items: InventoryOrderItem[]): Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                await InventoryOrderServ.updateInventoryOrderItems(inventoryOrderId, items);
                resolve();
            } catch (error) {
                reject('Error updating inventory order status: ' + error);
            }
        });
    };
    /** Devuelve los avisos de la recepción (el CEDIS sin registro, saldo negativo…). */
    updateStatus = (inventoryOrderId: string, status: InventoryOrderStatus): Promise<string[]> => {
        return new Promise(async (resolve, reject) => {
            try {
                const warnings = await InventoryOrderServ.updateStatus(inventoryOrderId, status);
                resolve(warnings);
            } catch (error) {
                reject('Error updating inventory order status: ' + error);
            }
        });
    };
    payInventoryOrder = (
        inventoryOrderId: string,
        subtotal: number,
        total: number,
        cashAmount: number,
        creditCardAmount: number,
        bankTransferAmount: number
    ): Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                await InventoryOrderServ.payInventoryOrder(
                    inventoryOrderId,
                    subtotal,
                    total,
                    cashAmount,
                    creditCardAmount,
                    bankTransferAmount
                );
                resolve();
            } catch (error) {
                reject('Error paying inventory order: ' + error);
            }
        });
    };
    bulkUpdateInventoryOrdersStatus = (
        orderIds: string[],
        newStatus: InventoryOrderStatus
    ): Promise<{ updated: number; failed: string[]; warnings: string[] }> => {
        return new Promise(async (resolve, reject) => {
            try {
                const result = await InventoryOrderServ.bulkUpdateInventoryOrdersStatus(orderIds, newStatus);
                resolve(result);
            } catch (error) {
                reject('Error updating inventory order status: ' + error);
            }
        });
    };
    deleteInventoryOrder = (inventoryOrderId: string): Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                await InventoryOrderServ.deleteInventoryOrder(inventoryOrderId);
                resolve();
            } catch (error) {
                reject('Error deleting inventory order: ' + error);
            }
        });
    };
}
export default InventoryOrderService;
